import React from "react";
import HeaderContainer from "./HeaderContainer";
import Brand from "./Brand";
import SideBarCollapse from "./SideBarCollapse";
import AccountArea from "./AccountArea";

const Header = (props) =>
	(<HeaderContainer>
		<Brand />
		<SideBarCollapse />
		<AccountArea />
	</HeaderContainer>);

export default Header;



/** WEBPACK FOOTER **
 ** ./src/scripts/components/header/Header.jsx
 **/